import request from '@/common/request'
/**
 *  create 增
 *  delete 删
 *  update 改
 *  query  查
*/
export default {
    createRole: (dynaSeg, data, params) => {
      return request({
        url: '/role',
        method: 'post',
        data,
        params
      })
    },
    deleteRole: (dynaSeg, data, params) => {
      return request({
        url: `/role/${dynaSeg.id}`,
        method: 'delete',
        data,
        params
      })
    },
    updateRole: (dynaSeg, data, params) => {
      return request({
        url: `/role/${dynaSeg.id}`,
        method: 'put',
        data,
        params
      })
    },
    queryRole: params => {
      return request({
        url: '/role',
        method: 'get',
        params
      })
    },
    getPermisByRole:params =>{
      return request({
        url: '/role/getPermisByRole',
        method: 'get',
        params
      })
    },
    addPermisByRole:(data,params)=>{
      return request({
        url: '/role/addPermisByRole',
        method: 'post',
        data,
        params
      })
    },
    getRoleList:()=>{
      return request({
        url: '/role/getRoleList',
        method: 'post'
      })
    },
    getTranscodeByRole: params => {
      return request({
        url: '/role/getTranscodeByRole',
        method: 'POST',
        params
      })
    }
  }



// WEBPACK FOOTER //
// ./src/api/modules/role.js